import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { LuX } from 'react-icons/lu';

interface IntegrationCardProps {
  icon: ReactNode;
  iconClassName?: string; // brand-tint color classes for the icon itself (e.g. text-blue-500)
  title: string;
  description: string;
  status?: ReactNode;
  onClose: () => void;
  children?: ReactNode;
}

// Detail-view shell rendered inside a Modal when a tile on the Integrations page grid is clicked
// — icon-chip + title + description + status header, then the integration's own connect/manage
// widget below. Lives inside the Modal's own panel chrome, so it has no card/shadow wrapper of
// its own.
const IntegrationCard: React.FC<IntegrationCardProps> = ({
  icon,
  iconClassName,
  title,
  description,
  status,
  onClose,
  children,
}) => (
  <div className="card-body p-5 gap-3">
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-start gap-3 min-w-0">
        <div
          className={clsx(
            'shrink-0 w-10 h-10 rounded-lg flex items-center justify-center text-xl bg-base-200',
            iconClassName,
          )}
        >
          {icon}
        </div>
        <div className="min-w-0">
          <div id="integration-modal-title" className="font-semibold">
            {title}
          </div>
          <div className="text-sm opacity-70">{description}</div>
        </div>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        {status}
        <button className="btn btn-ghost btn-sm btn-circle" onClick={onClose} title="Close">
          <LuX size={16} />
        </button>
      </div>
    </div>
    {children && (
      <>
        <div className="divider my-0" />
        {children}
      </>
    )}
  </div>
);

export default IntegrationCard;
